module.exports = __webpack_public_path__ + "media/boom.23a0ea4d.aac";